/* eslint-disable max-len */
import React, { useRef, useState,useEffect } from "react";
// import { useOnClickOutside } from "../../../../CommonMethods/OutsideClick";
import Debounce from "../../../../CommonMethods/Debounce";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { useGetSubDivQuery } from "../../../../features/organizationUserSlice";
import { useDispatch ,useSelector} from "react-redux";
import { setCurIndex,toggleRowSelection,selectAllRows,addAllInitially, fillEmptyArray, searchReducer} from "../../../../pages/ManageOrganizations/usersSlice"
import { useLocation } from "react-router-dom";

function renameKeyInArray(array, oldKey, newKey) {
    return array.map(obj => {
        if (obj.hasOwnProperty(oldKey)) {
            return { ...obj, [newKey]: obj[oldKey], [oldKey]: undefined };
        }
        return obj;
    });
}
export default function DropdownWithSearchSubDiv({
    label,
    id,
    placeholder,
    value,
    disabled,
    emptyField,
    index,
 
}
) {

    const ref = useRef();
    const location=useLocation()
    const dispatch=useDispatch()

    const selectedUsers=useSelector(state=>state?.userSelect?.selectedUsers)
    const curIndex=useSelector(state=>state?.userSelect?.selectedUsers?.curIndex)
    const checkedArr= useSelector(state=>state?.userSelect?.selectedUsers?.checkedArr)
    const [displayEmptyMsg,setDisplayEmptyMsg] = useState('')
    const orgId=useSelector((state)=>state?.systemConfigData?.organization_id)
    const [queryParams,setQueryParams] = useState(`dropdown=true&filter=true&organization_id=${orgId}`)
    const [skip,setSkip]=useState(false)
    let {data,isFetching,isLoading,status}=useGetSubDivQuery(queryParams)
    const [suggestions,setSuggestions] = useState('')
    const buttonRef = useRef(null);
    const dropdownRef=useRef(null);
    const [isOpen, setisOpen] = useState(false);
    // const [checkedArr,setCheckedArr] = useState([])
    // const [isCheckedAll,setIsCheckedAll] = useState(true)
    function handleIsCheckedAll(event){
        dispatch(selectAllRows([event.target.checked,renameKeyInArray(data?.data, 'subdivision_id', 'user_id')]))
    }
   

    // useOnClickOutside(ref, () => {
    //     setisOpen(false);
    // });
       
    const handleChange=(val)=>{
        if(val.trim()!==''){
            setDisplayEmptyMsg('')
            setQueryParams(`search=${encodeURIComponent(val.trim())}&dropdown=true&filter=true&organization_id=${orgId}`)
           
        }
        else{
            setQueryParams(`dropdown=true&filter=true&organization_id=${orgId}`)
        }
        
        
    }
    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        []
    );

    const calculateDropdownPosition = () => {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const spaceBelow = window?.innerHeight - buttonRect?.bottom-40;
        //40px
        const dropdownHeight =dropdownRef?.current?.clientHeight;
    
        if (spaceBelow < dropdownHeight) {
            dropdownRef.current.style.top = `${data?.data?.length>=3?'-190px':data?.data?.length===2?'-300px':data?.data?.length===1?'-126px':'-82px'}`;
        } else {
            dropdownRef.current.style.top = '105%';
        }
    };
    useEffect(() => {
        optimizedFn('')
        setSuggestions('')
        // window.addEventListener('resize', calculateDropdownPosition);
        // calculateDropdownPosition(); // Initial position calculation
        return () => {
            // window.removeEventListener('resize', calculateDropdownPosition);
        };
    }, [isOpen]);

    useEffect(()=>{
        if(data!==undefined){
            // calculateDropdownPosition()
            if(data?.data?.length===0)  {
                setDisplayEmptyMsg('No results found.')
                return
                
            } 
            setDisplayEmptyMsg('')
            selectedUsers?.data?.length===0&&dispatch(addAllInitially([renameKeyInArray(data?.data, 'subdivision_id', 'user_id'),"sub_div"]))
            if(checkedArr[0]!==undefined&&checkedArr[0][0]===null){
                dispatch(fillEmptyArray([renameKeyInArray(data?.data, 'subdivision_id', 'user_id')]))
            }
            dispatch(searchReducer([renameKeyInArray(data?.data, 'subdivision_id', 'user_id'),curIndex]))
        } 
    },[data])

    return (
        <>
            <div className='relative' ref={ref}>
                <label htmlFor='countryCode' className='text-xs font-semibold text-[#000] pb-1.5'>{label}</label>
                <button  ref={buttonRef} onClick={() => {dispatch(setCurIndex([index])),setisOpen(!isOpen)}} className={`border ${emptyField?'border-[#C81720]':'border-[#C5C9DA] '} rounded-lg px-3.5 py-[11px] text-base font-normal 
                                 text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`} disabled={disabled}>
                    <p id= {id} className={`${(checkedArr[0].length===0)?'text-[#52555D] ':'text-[#000B17] '}text-start text-sm more-lines`}>{(value === "" || value === undefined || value === true)
                        ? placeholder
                        : value}</p>
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpen?"transform rotate-180" : ""}`}/>
                </button>
                <ul className={`py-4 pr-1 xl:pl-4 pl-3.5 rounded-lg bg-white z-[9] absolute top-[72px] w-full left-0 border border-[#C5C9DA] ${isOpen ? "" : "hidden"}`} ref={dropdownRef}>
                    <li>
                        <ul>
                            <li>
                                <div className="relative pr-3">
                                    <label htmlFor=""></label>
                                    <input 
                                        type="text" 
                                        autoComplete={"off"}
                                        id="search-value"
                                        placeholder="Search by ID/name"
                                        className="border border-[#C5C9DA] rounded-[16px] pl-9 px-3 py-1.5 w-full outline-none" 
                                        onChange={e=>{setSuggestions(e.target.value);optimizedFn(e.target.value)}}
                                        value={suggestions}/>
                                    <img src="/images/search_gray.svg" alt="icon" className="absolute top-[50%] -translate-y-[50%] left-3"/>
                                </div>
                            </li>
                            {displayEmptyMsg==="" &&!(((isFetching&&status!=="fulfilled"&&status!=="rejected")||(data===undefined&&status!=="fulfilled"&&status!=="rejected")))?<li className='flex justify-between items-center xl:p-2 py-2 pr-2 pl-1 pr-4'>
                                <div className="relative checkbox custom-checkBoxBlue1">
                                    <input type="checkbox" id='id1' checked={selectedUsers.isCheckedAll[curIndex]} onChange={(e)=>handleIsCheckedAll(e)} className='prevent-click' />
                                    <label htmlFor='id1' className={`text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4`}>Select All</label>
                                </div>
                                <button onClick={()=>{dispatch(selectAllRows([false,renameKeyInArray(data?.data, 'subdivision_id', 'user_id')]))}} type='button' className={selectedUsers?.checkedArr[curIndex]?.length===0?'hidden':`text-xs font-semibold text-[#008586]`}>
                                    Clear All
                                </button>
                            </li>:<p className="mt-2 text-center">{displayEmptyMsg}</p>}
                        </ul>
                        {((isFetching&&status!=="fulfilled"&&status!=="rejected")||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))? <div className=' h-[30px] relative   px-4 xl rounded-lg mt-3 '>
                            <div className='flex justify-center items-center mt-[90px]'>
                                                           
                                <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12  mt-[-45px] spin-animation"></div>
                                                           
                                                            
                            </div>
                        </div>:<ul>
                            <li>
                                <ul className={`max-h-[100px] overflow-auto scrollbar_gray pr-3`}>
                                    {
                                        data?.data?.map((item,i)=>(
                                            <li key={i} className='flex justify-between items-center xl:p-2 py-2 pr-2 pl-1'>
                                                <div className="relative checkbox custom-checkBoxBlue1 flex items-center">
                                                    <input type="checkbox" id={i} onChange={()=>dispatch(toggleRowSelection([item?.subdivision_id,renameKeyInArray(data?.data, 'subdivision_id', 'user_id')]))} checked={selectedUsers?.checkedArr[curIndex]?.includes(item?.subdivision_id)?true:false} className=' prevent-click' />
                                                    <label title={item?.subdivision_id+"-"+item?.sub_division_name} htmlFor={i} className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4 more-lines">{item?.subdivision_id} {item?.sub_division_name}</label>
                                                </div>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </li>
                        </ul>}
                    </li>
                 
                </ul>           
            </div>
        </>
    )
}
